import React from "react";

import { Radio } from "clearsense-ui/components";

import { SEARCH_CODE, SEARCH_DESCRIPTION, SELECTED_OPTION } from "../constants";

const Options = ({ setSearchType, searchType, clearSearchValues }) => {
  const handleOnChange = event => {
    setSearchType({ ...SELECTED_OPTION[event.target.value] });
    clearSearchValues("option change");
  };

  return (
    <Radio onChange={handleOnChange}>
      <Radio.Item
        data-cy="code-radio-button"
        label={`Search by ${SEARCH_CODE.label}`}
        name="options"
        value={SEARCH_CODE.value}
        checked={searchType.value === SEARCH_CODE.value}
      />
      <Radio.Item
        data-cy="description-radio-button"
        label={`Search by ${SEARCH_DESCRIPTION.label}`}
        name="options"
        value={SEARCH_DESCRIPTION.value}
        checked={searchType.value === SEARCH_DESCRIPTION.value}
      />
    </Radio>
  );
};

export default Options;
